import { Injectable } from '@angular/core';
import { CustomCart } from '@cart/const';
import { CartActions, CustomActiveCartService } from '@cart/data-access';
import { CompanyActions, CompanySelectors, StateWithCompany } from '@company/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { CustomUserActions } from '@user/data-access';
import { Observable, from } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { CompanyService } from '../services';

@Injectable()
export class SelectCompanyEffects {
  selectAfterAddCompany$: Observable<CompanyActions.SelectCompany> = createEffect(() =>
    this.actions$.pipe(
      ofType<CompanyActions.LoadUserCompaniesSuccess>(CompanyActions.LOAD_USER_COMPANIES_SUCCESS),
      map((action) => action.payload),
      concatLatestFrom(() => this.companyService.getAddedCompanyUid()),
      filter(([userCompanies, lastAddedCompanyUid]) => userCompanies.some((c) => c.uid === lastAddedCompanyUid)),
      map(([, lastAddedCompanyUid]) => new CompanyActions.SelectCompany(lastAddedCompanyUid)),
    ),
  );

  resetSelectedCompanyAfterRemove$: Observable<CompanyActions.ResetSelectedCompany> = createEffect(() =>
    this.actions$.pipe(
      ofType<CompanyActions.RemoveCompanySuccess>(CompanyActions.REMOVE_COMPANY_SUCCESS),
      /* берем значение напрямую из стора, так как в сервисе CompanyService
      на получение значения навешана дополнительная логика */
      concatLatestFrom(() => this.store.select(CompanySelectors.getSelectedCompany)),
      filter(([action, selectedCompanyUid]) => action.payload === selectedCompanyUid),
      map(() => new CompanyActions.ResetSelectedCompany()),
    ),
  );

  selectCompanyAfterLoadCart$: Observable<
    CompanyActions.SelectCompany | CompanyActions.ResetSelectedCompany | CustomUserActions.SetLegalEntityStatus
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActions.LOAD_CART_SUCCESS, CartActions.SET_ACTIVE_CART_ID),
      switchMap(() => this.activeCartService.takeActive()),
      map((cart: CustomCart) => cart.organizationUid),
      distinctUntilChanged(),
      switchMap((organizationUid?: string) =>
        from([
          organizationUid
            ? new CompanyActions.SelectCompany(organizationUid)
            : new CompanyActions.ResetSelectedCompany(),
          new CustomUserActions.SetLegalEntityStatus(Boolean(organizationUid)),
        ]),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private companyService: CompanyService,
    private store: Store<StateWithCompany>,
    private activeCartService: CustomActiveCartService,
  ) {}
}
